import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getNeededDateFormat } from '../../../../helper'
import MainIcon from '../../../../img/svg/main'
import Button from '../../../Elements/buttons/Button'
import CustomModal from '../../../Elements/modal/CustomModal'
import { EmptyNullOrder, NullOrderBlock, NullOrderDataWrapper, NullOrdersWrapper, TseInformationButtonsWrap, TseInformationModalWrapper } from '../index.styled'
import { selectHasYearOrder } from '../../../../redux/selector/tse'

const EVENT_Z_INDEX = 997

const NullOrderModal = React.memo(({ isOpen, handlePrint, handleClose, handleYearOrderPrint }) => {
	const { t } = useTranslation()
	const nullOrders = useSelector(store => store.tse.nullOrders)
	const isProcessingPrintYearOrder = useSelector(store => store.tse.isProcessingPrintYearOrder)
	const hasYearOrder = useSelector(selectHasYearOrder)

	return (
		<CustomModal
			isOpen={isOpen}
			close={handleClose}
			zIndex={EVENT_Z_INDEX}
			size="medium height-scroll"
			title={t('Modal.tse_modal.information.nullOrder')}
			disableBackButton={true}
			id="null-order-modal"
			dividedFooterLine={nullOrders?.length}
			button={
				<>
					<TseInformationButtonsWrap>
						{isOpen &&
							<Button name="send" icon="print" text={t('Modal.tse_modal.information.print')} keyButton="F2" zIndex={EVENT_Z_INDEX} color="green" onClick={handlePrint} className="back no-print" />}
						{hasYearOrder && <Button icon="print" text={t('Modal.tse_modal.information.yearOrder')} color="green" onClick={handleYearOrderPrint} disabled={isProcessingPrintYearOrder} />}
					</TseInformationButtonsWrap>
					<Button icon="checkmark" text={t('buttons.controls.ready')} color="green" onClick={handleClose} className="no-print" />
				</>
			}>
			<TseInformationModalWrapper>
				<NullOrderDataWrapper>
					{nullOrders?.length ?
						<NullOrdersWrapper>
							{nullOrders.map(order =>
								<NullOrderBlock key={order.id}>
									<MainIcon icon="check" />
									{getNeededDateFormat(order.date, 'dd.MM.y')}
								</NullOrderBlock>)}
						</NullOrdersWrapper> :
						<EmptyNullOrder>
							<MainIcon icon="check" />
							{t('Modal.tse_modal.information.emptyNullOrders')}
						</EmptyNullOrder>}
				</NullOrderDataWrapper>
			</TseInformationModalWrapper>
		</CustomModal>
	)
})

NullOrderModal.displayName = 'NullOrderModal'
export default NullOrderModal
